import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import _get from 'lodash/get';
import { callActions, moderatorActions, remoteModeratorActions } from '@lifesize/nucleus';
import { closeInCallModal } from 'actions/InCallModal';
import { setPillNotificationWithTimeout } from 'actions/Notification';
import EndCallForAllModal from 'components/EndCallForAllModal/EndCallForAllModal';

const messages = defineMessages({
  endMeetingForAllFailed: {
    id: 'components.remoteModeratorPanel.notification.kickAllFailed',
    defaultMessage: 'Failed to remove all participants'
  }
});

const mapStateToProps = (state, ownProps) => {
  const isModerator = ownProps.isModerator;
  const isMeeting = _get(ownProps, 'conference.type') === 'VMR';
  const isFullyConnected = ownProps.callConnected;
  return {
    isModerator,
    isMeeting,
    isFullyConnected
  };
};

const mapActionCreators = (dispatch, ownProps) => ({
  onCancelClicked: () => {
    dispatch(closeInCallModal());
  },
  onEndCallClicked: () => {
    dispatch(closeInCallModal({ endCalled: true }));
    dispatch(callActions.end());
  },
  onKickAllClicked: async () => {
    dispatch(closeInCallModal({ endCalled: true }));
    if (ownProps.isRemoteModerator) {
      try {
        await dispatch(moderatorActions.ejectAllParticipants());
        dispatch(remoteModeratorActions.leaveCurrent());
      } catch {
        dispatch(setPillNotificationWithTimeout(ownProps.intl.formatMessage(messages.endMeetingForAllFailed)));
      }
    } else {
      dispatch(callActions.kickAll());
    }
  }
});

const ConnectedComponent = injectIntl(connect(mapStateToProps, mapActionCreators)(EndCallForAllModal));

const FunctionalWrapper = (props) => {
  const isModerator = hooks.useIsCurrentUserModerator();
  const conference = hooks.useConferenceInfo();
  const callConnected = hooks.useCallConnected();

  return (
    <ConnectedComponent isModerator={isModerator} conference={conference} callConnected={!!callConnected} {...props} />
  );
};
export { ConnectedComponent as EndCallForAllModalContainer };
export default FunctionalWrapper;
